import styled from "styled-components";
import { colors } from "src/theme/colors";

const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.005em;
  margin-right: 8px;
  color: ${colors.gray[700]};
`;

export default Title;
